import { useMemo } from 'react';
import { useFetch } from './useFetch';

function useReturnedApprovalItems() {
  const { data } = useFetch('/api/approvals/my-returned', { initialData: [] });

  return useMemo(() => (Array.isArray(data) ? data : []), [data]);
}

export default useReturnedApprovalItems;
